import { MEntityStatusBadge } from '../../../../components/Monetize/MEntityStatusBadge';
import { useFlags } from '../../../../services/launchDarkly';

interface InvoiceTransformationBadgeProps {
  hasActiveTransformationPipeline?: boolean | null;
  onClick?: () => void;
}

export const InvoiceTransformationBadge = ({
  hasActiveTransformationPipeline,
  onClick,
}: InvoiceTransformationBadgeProps) => {
  const { enableInvoiceSplit } = useFlags();

  if (!enableInvoiceSplit || !hasActiveTransformationPipeline) {
    return null;
  }

  return (
    <MEntityStatusBadge
      as={onClick ? 'button' : undefined}
      status="Output Rules Active"
      variant="blue"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'unset'}
    />
  );
};
